import { LinkInterface } from "@/interface/nav.interface";
import { LinksConstrains } from "@/enums/links.enum";
import { NAV_BADGE } from "@/enums/apps.enum";

const links: Array<LinkInterface> = [
  {
    title: "menu.dashboard",
    icon: "dashboard",
    href: LinksConstrains.CALL_CENTER_DASHBOARD,
  },
  {
    title: "menu.today_orders",
    icon: "orders",
    href: LinksConstrains.CALL_CENTER_ORDERS,
  },
  {
    title: "menu.items",
    icon: "items-list",
    href: LinksConstrains.CALL_CENTER_ITEMS,
  },
  {
    title: "menu.customers",
    icon: "customers",
    href: LinksConstrains.CALL_CENTER_CUSTOMERS,
  },
  {
    title: "menu.history",
    icon: "history",
    href: LinksConstrains.CALL_CENTER_ORDERS_HISTORY,
  },
  {
    title: "menu.communications",
    icon: "communication",
    href: LinksConstrains.CALL_CENTER_CHAT,
    badgeId: NAV_BADGE.CHART_NOTIFICATION_BADGE,
  },
];

export default links;
